import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, CTA_LABEL, OFFER_ANCHOR } from '../utils/checkout';
interface CTAButtonProps {
  className?: string;
  /** 'offer' scrolls to the launch-offer section, 'checkout' goes to the checkout. */
  target?: 'offer' | 'checkout';
}
export function CTAButton({
  className = '',
  target = 'offer'
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : OFFER_ANCHOR} className={`cta-attention inline-flex min-h-[56px] items-center justify-center gap-2 rounded-full bg-brand-accent px-8 py-4 text-center text-sm font-extrabold tracking-wide text-white shadow-md transition-[background-color,box-shadow] duration-200 ease-out hover:bg-[#e85a26] hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 md:text-base ${className}`} data-id="element-58" data-mp="2tz33y7hngedm">
      {CTA_LABEL}
      <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-59" data-mp="38paaboudu6xy" />
    </a>;
}